export default function pluralize(number, word, pluralSuffix = 's', singularSuffix = '') {
  return `${number} ${word}${number !== 1 ? pluralSuffix : singularSuffix}`;
}
